//#region ../../node_modules/@jwplayer/fe-common/module/event-manager/index.js
/**
* Handle subscribing to and emiting events in a type-safe way.
*
* @example
* ```ts
* const myManager = new EventManager<{
*   foo: (num: number) => void;
*   bar: () => void;
*   baz: (str: string, obj: { a: number; b: number }) => void;
* }>();
*
* myManager.subscribe('baz', (str, { a, b }) => {
*   console.log(str, a, b);
* });
*
* myManager.emit('baz', 'hi', { a: 1, b: 2 }); // will log "'hi', 1, 2"
* ```
*/
var EventManager = class {
	eventHandlers = {};
	/**
	* Emit event (with arguments)
	*
	* @param event Event name
	* @param args Event args
	*/
	emit = (event, ...args) => {
		if (event in this.eventHandlers && this.eventHandlers[event]) for (const handler of this.eventHandlers[event]) handler(...args);
	};
	/**
	* Subscribe to event
	*
	* Returns function to unsubscribe
	*
	* @param event Event name
	* @param handler Event handler
	*/
	subscribe = (event, handler) => {
		this.eventHandlers[event] ??= [];
		if (!this.eventHandlers[event].includes(handler)) this.eventHandlers[event].push(handler);
		/**
		* Unsubscribe
		*/
		return () => {
			if (event in this.eventHandlers && this.eventHandlers[event]) this.eventHandlers[event] = this.eventHandlers[event].filter((h) => h !== handler);
		};
	};
};

//#endregion
export { EventManager };